import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.lead,
  textColorDark: colors.lead,
  textColorLight: colors.white
};
export default fiftyFiftyCard;